import { useMutation } from 'react-query';
import { authFetchBlob } from '../../CommonUtils/authFetchBlob';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { ProviderType } from '../DocumentVault.meta';

interface DownloadFolderParams {
  clientId: string;
  path: string;
  providerType: ProviderType;
}

const downloadFolder = ({ clientId, path, providerType }: DownloadFolderParams) => {
  return authFetchBlob(
    urlWithParams(
      '/Consumer/DocumentVault/DownloadFolderAsZip',
      {
        clientId,
        FolderPath: path,
        providerType,
      },
      { skipNulls: true },
    ),
  );
};

export const useDownloadFolderMutation = () => {
  return useMutation(downloadFolder);
};
